export const tokens = {
  fonts: {
    sans: '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    serif: '"Newsreader", "Playfair Display", "Cormorant Garamond", Georgia, serif',
    mono: '"JetBrains Mono", "Fira Code", monospace',
  },
  colors: {
    light: {
      // Warm Luxury Linen / Parchment Base
      bgPrimary: "#f8f5ee",
      bgSecondary: "#f1ebd9",
      bgCard: "#ffffff",
      bgCardGlass: "rgba(255, 255, 255, 0.88)",
      bgElevated: "#eae3d1",
      bgCode: "#16181e",
      
      // Typography
      textPrimary: "#18130e",
      textSecondary: "#4b3d30",
      textMuted: "#7a6a57",
      
      // Architectural Borders & Glass Rings
      borderSubtle: "rgba(138, 92, 54, 0.12)",
      borderMedium: "rgba(138, 92, 54, 0.24)",
      borderStrong: "#3d2b1f",
      borderGlow: "rgba(184, 134, 11, 0.35)",
      
      // Primary & Secondary Accents
      accentPrimary: "#b45309",
      accentSecondary: "#92400e",
      accentBronze: "#8b5a2b",
      accentMuted: "rgba(180, 83, 9, 0.08)",
      accentBorder: "rgba(180, 83, 9, 0.25)",

      // Vibrant Highlights (Light Mode)
      accentCyan: "#0284c7",
      accentEmerald: "#059669",
      accentPurple: "#7c3aed",
      accentAmber: "#d97706",
      accentRose: "#e11d48",
      accentIndigo: "#4f46e5",
      
      // Tags
      tagBg: "rgba(138, 92, 54, 0.06)",
      tagText: "#4a3525",
      tagBorder: "rgba(138, 92, 54, 0.18)",
      
      // Ambient Grid
      gridColor: "rgba(138, 92, 54, 0.045)",
      glowColor: "rgba(184, 134, 11, 0.14)"
    },
    dark: {
      // Obsidian Codex & Illuminated Glass Base
      bgPrimary: "#0a0c10",
      bgSecondary: "#10141d",
      bgCard: "#131722",
      bgCardGlass: "rgba(19, 23, 34, 0.85)",
      bgElevated: "#1b212f",
      bgCode: "#07080b",
      
      // Typography
      textPrimary: "#f8fafc",
      textSecondary: "#cbd5e1",
      textMuted: "#94a3b8",
      
      // Architectural Borders & Glass Rings
      borderSubtle: "rgba(229, 169, 60, 0.14)",
      borderMedium: "rgba(229, 169, 60, 0.25)",
      borderStrong: "#e5a93c",
      borderGlow: "rgba(229, 169, 60, 0.45)",
      
      // Primary & Secondary Accents
      accentPrimary: "#e5a93c",
      accentSecondary: "#fbbf24",
      accentBronze: "#f59e0b",
      accentMuted: "rgba(229, 169, 60, 0.12)",
      accentBorder: "rgba(229, 169, 60, 0.35)",

      // Vibrant Highlights (Dark Mode)
      accentCyan: "#38bdf8",
      accentEmerald: "#34d399",
      accentPurple: "#c084fc",
      accentAmber: "#fbbf24",
      accentRose: "#fb7185",
      accentIndigo: "#a5b4fc",
      
      // Tags
      tagBg: "rgba(229, 169, 60, 0.08)",
      tagText: "#f1f5f9",
      tagBorder: "rgba(229, 169, 60, 0.22)",
      
      // Ambient Grid
      gridColor: "rgba(229, 169, 60, 0.04)",
      glowColor: "rgba(229, 169, 60, 0.2)"
    }
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "48px",
    xxxl: "64px",
    huge: "96px"
  },
  radii: {
    none: "0px",
    xs: "4px",
    sm: "8px",
    md: "14px",
    lg: "18px",
    xl: "24px",
    full: "9999px"
  },
  shadows: {
    none: "none",
    subtle: "0 2px 6px rgba(0, 0, 0, 0.04)",
    card: "0 8px 24px -6px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(255, 255, 255, 0.06)",
    cardHover: "0 18px 40px -10px rgba(0, 0, 0, 0.32), 0 0 28px rgba(229, 169, 60, 0.16)",
    glass: "0 10px 30px -5px rgba(0, 0, 0, 0.25), inset 0 0 0 1px rgba(255, 255, 255, 0.1)"
  },
  transitions: {
    fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
    normal: "250ms cubic-bezier(0.16, 1, 0.3, 1)",
    smooth: "400ms cubic-bezier(0.16, 1, 0.3, 1)"
  }
};
